<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/x9xrGC/tc-custom/9780226724607.jpg?1737196285961" alt="This image is the cover for the book Kiss My Relics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kiss My Relics
      </h1>
      <p class="bookDescription body article font2">
        <p>Conservative thinkers of the early Middle Ages conceived of sensual gratification as a demonic snare contrived to debase the higher faculties of humanity, and they identified pagan writing as one of the primary conduits of decadence. Two aspects of the pagan legacy were treated with particular distrust: fiction, conceived as a devious contrivance that falsified God’s order; and rhetorical opulence, viewed as a vain extravagance. Writing that offered these dangerous allurements came to be known as “hermaphroditic” and, by the later Middle Ages, to be equated with homosexuality. At the margins of these developments, however, some authors began to validate fiction as a medium for truth and a source of legitimate enjoyment, while others began to explore and defend the pleasures of opulent rhetoric. Here David Rollo examines two such texts—Alain de Lille’s <i>De planctu Naturae</i> and Guillaume de Lorris and Jean de Meun’s <i>Roman de la Rose</i>—arguing that their authors, in acknowledging the liberating potential of their irregular written orientations, brought about a nuanced reappraisal of homosexuality. Rollo concludes with a consideration of the influence of the latter on Chaucer’s <i>Pardoner’s Prologue and Tale</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Rollo
      </h2>
      
      <p class="authorDescription body article"><B>David Rollo</B> is associate professor of English, with a joint appointment in the Department of French and Italian, at the University of Southern California. He is the author of two books, most recently of <I>Glamorous Sorcery: Magic and Literacy in the High Middle Ages</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61684b36